module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/tfl_community_banner.65c957250495bb79972b8443ba68b8a7.png";